import { NodonEnvironment } from '@shared/models/environment.model';

const FAVICON_HREF_BY_ENVIRONMENT: Record<NodonEnvironment, string> = {
  [NodonEnvironment.Localhost]: '/favicon-localhost.ico',
  [NodonEnvironment.Development]: '/favicon-development.ico',
  [NodonEnvironment.Production]: '/favicon.ico',
};

/**
 * Favicon path for the current deployment environment.
 * Localhost and test use hue-shifted variants so tabs are easy to tell apart.
 */
export const getFaviconHref = (environment: NodonEnvironment): string =>
  FAVICON_HREF_BY_ENVIRONMENT[environment];

/**
 * Update the document favicon link for the given href.
 */
export const setDocumentFavicon = (href: string): void => {
  const selector = "link[rel='icon']";
  const existing = document.querySelector<HTMLLinkElement>(selector);

  if (existing) {
    existing.href = href;
    return;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = href;
  document.head.appendChild(link);
};
